import { render } from "./SingleRow.vue?vue&type=template&id=5c39e04a&scoped=true"
import script from "./SingleRow.vue?vue&type=script&lang=js"
export * from "./SingleRow.vue?vue&type=script&lang=js"

import "./SingleRow.vue?vue&type=style&index=0&id=5c39e04a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c39e04a"]])

export default __exports__